import { FormattedMessage } from 'react-intl';

import { SignDocumentStep } from '../../SignDocumentStep/SignDocumentStep';

export const SignRefinancingSideLetter = () => {
    return (
        <SignDocumentStep
            title={
                <FormattedMessage
                    id="_.funding_requirements.refinancing_side_letter_step.title"
                    defaultMessage="Sign refinancing side letter"
                />
            }
            subtitle={
                <FormattedMessage
                    id="_.funding_requirements.refinancing_side_letter_step.subtitle"
                    defaultMessage="Please read the entire letter and click 'Sign refinancing side letter' to continue."
                />
            }
            buttonLabel={
                <FormattedMessage
                    id="_.funding_requirements.refinancing_side_letter_step.sign_button"
                    defaultMessage="Sign refinancing side letter"
                />
            }
            type="refinancing_side_letter"
            requirementType="REFINANCING_SIDE_LETTER"
        />
    );
};
